// frontend/src/components/AppCommon.js
import React from 'react';

export const Card = ({ children, className = '' }) => <div className={`card ${className}`}>{children}</div>;

export const ButtonGroup = ({ children }) => <div className="btn-group">{children}</div>;

export const LoadingOverlay = ({ message }) => (
  <div className="loading-overlay">
    <div className="spinner"></div>
    <p>{message}</p>
  </div>
);

export const SelectBox = ({ label, value, options, onChange, helpText, disabled }) => (
  <div className="form-group">
    <label className="form-label">{label}：</label>
    <select value={value} onChange={onChange} className="form-select" disabled={disabled}>
      <option value="">{`请选择${label}...`}</option>
      {options.map((opt) => (
        <option key={opt.value || opt} value={opt.value || opt}>
          {opt.label || opt}
        </option>
      ))}
    </select>
    {helpText && <p className="form-help">{helpText}</p>}
  </div>
);

export const DocumentTypeCard = ({ type, title, desc, selected, onSelect }) => (
  <div
    className={`document-type-card ${selected ? 'selected' : ''}`}
    onClick={() => onSelect(type)}
    role="button"
    tabIndex="0"
    onKeyPress={(e) => (e.key === 'Enter' || e.key === ' ') && onSelect(type)}
  >
    <h4>{title}</h4>
    <p className="card-desc">{desc}</p>
  </div>
);

export const DeviceOption = ({ device, selected, onSelect }) => (
  <div
    className={`device-option ${selected ? 'selected' : ''}`}
    onClick={() => onSelect(device.value)}
    role="button"
    tabIndex="0"
    onKeyPress={(e) => (e.key === 'Enter' || e.key === ' ') && onSelect(device.value)}
    aria-label={`选择${device.label}`}
  >
    <div className="device-title">{device.label}</div>
    <div className="device-desc">{device.desc}</div>
  </div>
);

export const TransformationControls = ({
  currentTransformationType,
  offsetAmount,
  onOffsetAmountChange,
  onApplyOpposite,
  onApplyAbsolute,
  onApplyNegative,
  onApplyIncrease,
  onApplyDecrease,
  onReset,
}) => {
  const isTransformed = currentTransformationType !== 'original';

  return (
    <div className="transform-section">
      <h4>数值转换操作</h4>
      <div className="transform-buttons">
        <button className="btn transform-btn" onClick={onApplyOpposite} disabled={currentTransformationType === 'opposite'}>一键相反数</button>
        <button className="btn transform-btn" onClick={onApplyAbsolute} disabled={currentTransformationType === 'absolute'}>一键正数</button>
        <button className="btn transform-btn" onClick={onApplyNegative} disabled={currentTransformationType === 'negative'}>一键负数</button>
        <input
          type="number"
          className="form-select"
          value={offsetAmount}
          onChange={(e) => onOffsetAmountChange(e.target.value)}
          placeholder="增减数量"
          min="0"
          step="0.01"
          style={{ maxWidth: '140px' }}
        />
        <button className="btn transform-btn" onClick={onApplyIncrease}>一键增加</button>
        <button className="btn transform-btn" onClick={onApplyDecrease}>一键减少</button>
        <button className={`btn ${isTransformed ? 'btn-danger' : 'btn-secondary'}`} onClick={onReset} disabled={!isTransformed}>一键还原</button>
      </div>
      {isTransformed && <p className="transform-note"><strong>提示：</strong>当前显示为转换后数据，导出将包含此转换。</p>}
    </div>
  );
};